import Instance from '../../../../Axios';

// New Actions for the app

const GetObrasTrabalhos = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/obras/all/trabalhos`)
    .then(({ data }) => {
      dispatch({ type: 'GET_OBRAS_TRABALHOS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetObrasTrabalhos;
